export default __webpack_public_path__ + "static/certificate-relay-square-8163455005855bac3a3e22b1af890af6.png";